import { applyMiddleware, combineReducers, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { persistReducer, persistStore } from 'redux-persist'
import LocalStorage from 'redux-persist/lib/storage'

import commonCombinedReducer from '../../common/redux/reducers'

import accountCombinedReducer from '../../account/redux/reducers'
import aiSettingsCombinedReducer from '../../ai-settings/redux/reducers/ai-settings-reducer'
import brandCurationTasksCombinedReducer from '../../brand-curation-tasks/redux/reducers'
import dishesCombinedReducer from '../../dishes/redux/reducers'
import locationsCombinedReducer from '../../locations/redux/reducers'
import menuCurationTasksCombinedReducer from '../../menu-curation-tasks/redux/reducers'
import menuTitlesReducer from '../../menu-title/redux/reducers'
import priorityTasksReducer from '../../priority-tasks/redux/reducers'
import reportsCombinedReducer from '../../reports/redux/reducers'
import sopsCombinedReducer from '../../sops/redux/reducers'
import unknownWordsCombinedReducer from '../../unknown-words/redux/reducers'
import usersCombinedReducer from '../../users/redux/reducers'

const rootReducer = combineReducers({
  common: commonCombinedReducer,
  account: persistReducer(
    {
      key: 'account',
      storage: LocalStorage,
      blacklist: ['login', 'updateUserSettings', 'refreshAccessToken'],
    },
    accountCombinedReducer,
  ),
  users: usersCombinedReducer,
  sops: sopsCombinedReducer,
  brandCurationTasks: brandCurationTasksCombinedReducer,
  menuCurationTasks: menuCurationTasksCombinedReducer,
  locations: locationsCombinedReducer,
  dishes: dishesCombinedReducer,
  unknownWords: unknownWordsCombinedReducer,
  aiSettings: aiSettingsCombinedReducer,
  menuTitles: menuTitlesReducer,
  priorityTasks: priorityTasksReducer,
  reports: reportsCombinedReducer,
})

const composeEnhancers = composeWithDevTools({})

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware()),
)

export const persistor = persistStore(store)
